/* unplugin-vue-components disabled */import { render } from "./ColorGridMemory.vue?vue&type=template&id=5e4b3221&scoped=true"
import script from "./ColorGridMemory.vue?vue&type=script&lang=js"
export * from "./ColorGridMemory.vue?vue&type=script&lang=js"

import "./ColorGridMemory.vue?vue&type=style&index=0&id=5e4b3221&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4b3221"]])

export default __exports__